///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const AlertIcon = ({
  height,
  fill = "#F46F0E",
  title = messages.alert.defaultMessage,
  width,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="alert-icon"
    width={width}
    height={height}
    fill="none"
    {...rest}
  >
    <path
      fill={fill}
      d="M0 13.818h16L8 0 0 13.818Zm8.727-2.182H7.273v-1.454h1.454v1.454Zm0-2.909H7.273V5.818h1.454v2.91Z"
    />
  </svg>
);

export default AlertIcon;
